export default  {  
    API: 'https://api.mroam.sogak.com.mx' ,    //https://api.mroam.sogak.com.mx /desarrollo https://api.mroamdes.sogak.com.mx
    SOCKET:"https://mrosockets.sogak.com.mx",  //https://appmroaam.com:16500
}
